class AppointmentReferenceService {
    buildReferenceList(customerReferenceMap) {
        const displayStrings = [];

        for(var key in customerReferenceMap) {
            const valueFromService = customerReferenceMap[key];
            if (valueFromService) {
                displayStrings.push(`${key}: ${valueFromService}`);
            }
        }

        return displayStrings;
    }
}

export const appointmentReferenceService = new AppointmentReferenceService();